import React from "react";
import { useRef, useState, useEffect } from "react";
import { DetailsList, IColumn, DetailsListLayoutMode, Selection, SelectionMode, IDetailsRowProps, DetailsRow, ConstrainMode } from "@fluentui/react/lib/DetailsList";
import styles from "./CompList.module.css";
import { PrimaryButton, Modal, IStyle } from "@fluentui/react";
import { gloggedinuser, gnewcomp, gcompflat } from "../../interfaces";
import { qIsG } from "../../api/qpi";
import AddCompanyModal from "../AddCompanyModal/AddCompanyModal";

interface ICompListProps {
    comps: gcompflat[];
    newActiveComp: (newActiveComp: gcompflat) => void;
    activeComp: any;
    loggedInUser: gloggedinuser;
    src?: string;
}

const columns: IColumn[] = [
    { key: "column1", name: "Id",   fieldName: "companyid",   minWidth: 100, maxWidth: 200, isResizable: true },
    { key: "column2", name: "Name", fieldName: "companyname", minWidth: 100, maxWidth: 200, isResizable: true }
];

const CompList: React.FC<ICompListProps> = ({ comps, newActiveComp, activeComp, loggedInUser, src }) => {
    const [selectedCompany, setSelectedCompany] = useState<any>("");
    const [compsState, setCompsState] = useState<gcompflat[]>(comps);
    const [isG, setIsG] = useState<boolean>(false);
    const [isCreateCompOpen, setIsCreateCompOpen] = useState<boolean>(false);

    useEffect(() => {
        qIsG(loggedInUser).then(res => setIsG(res));
    }, [loggedInUser]);
    const selection = new Selection({
        onSelectionChanged: () => {
            const selectedItem = selection.getSelection()[0] as gcompflat;
            setSelectedCompany(selectedItem ? selectedItem : {});
        },
        selectionMode: SelectionMode.single
    });
    const refreshComps = (newComp: gnewcomp) => {
        setCompsState(prev => [
            ...prev,
            {
                companyid: newComp.companyid,
                companyname: newComp.companyname,
                permissionlevel: 3,
                licensingkind: newComp.licensingkind,
                alloweddomains: "",
                allowqueststocreate: 1
            }
        ]);
        setIsCreateCompOpen(false);
        window.location.href = `/#/${newComp.companyid}`;
        window.location.reload();
    };
    const onActiveItemChanged = (item: any) => {
        newActiveComp(item);
    };
    const customStyles = {
        root: { cursor: "pointer" }
    };
    const controlCompStyles = {
        root: {
            paddingTop: "0px !important",
            overflowY: "scroll"
        },
        commandButton: {
            marginRight: "20px",
            marginBottom: "20px"
        },
        headerWrapper: {
            position: "sticky",
            top: 0,
            zIndex: 1,
            borderRadius: "5px 5px 0 0"
        } as IStyle,
        detailsHeader: { padding: "0px" }
    };
    return (
        <div className={src === "modal" ? styles.contMa : styles.contMaFull} id="kgnfmodcomp">
            <Modal
                isOpen={isCreateCompOpen}
                onDismiss={() => {
                    setIsCreateCompOpen(false);
                }}
                isBlocking={false}
                containerClassName={styles.modalNewComp}
            >
                <AddCompanyModal refreshComps={refreshComps} comps={comps} loggedInUser={loggedInUser} />
            </Modal>

            <div className={styles.userListHead}>
                {isG && (
                    <PrimaryButton
                        className={styles.changeActiveComp}
                        text="New Company"
                        disabled={false}
                        iconProps={{ iconName: "List" }}
                        onClick={() => {
                            setIsCreateCompOpen(true);
                        }}
                    />
                )}
            </div>
            <div style={{ height: src == "modal" ? "calc(80vh - 40px)" : "calc(100vh - 150px)", width: src == "modal" ? "100%" : "100vw", overflow: "scroll" }}>
                <DetailsList
                    items={compsState}
                    columns={columns}
                    className={styles.glCompListList}
                    setKey="set"
                    layoutMode={DetailsListLayoutMode.justified}    // adjust layout mode as needed
                    constrainMode={ConstrainMode.horizontalConstrained}
                    selectionPreservedOnEmptyClick={true}
                    selection={selection}
                    onActiveItemChanged={onActiveItemChanged}       // single click or keyboard interaction
                    ariaLabelForSelectionColumn="Toggle selection"
                    ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                    styles={controlCompStyles}
                    onItemInvoked={item => {
                        setSelectedCompany(item);
                        newActiveComp(item);
                    }}
                    onRenderRow={(prps: IDetailsRowProps | undefined): JSX.Element => {
                        return <DetailsRow {...(prps as IDetailsRowProps)} styles={customStyles} />;
                    }}
                    onShouldVirtualize={() => compsState?.length > 80}
                />
            </div>
        </div>
    );
};

export default CompList;
